
import { createReducer } from '@client/redux/utils';
import types from './types';

export const initialState = {
    width: 1024,
    height: null, // TODO why null
    offsetTop: 0,
    webviewOs: false,
    tabVisible: false
};

const ACTION_HANDLERS = {
    [types.WIDTH_UPDATED]: (state, action) => ({ ...state, width: action.payload }),
    [types.HEIGHT_UPDATED]: (state, action) => ({ ...state, height: action.payload }),
    [types.WEBVIEW_OS_UPDATED]: (state, action) => ({ ...state, webviewOs: action.payload }),
    [types.SET_CLIENT_OFFSET_TOP]: (state, action) => ({
        ...state,
        offsetTop: action.payload,
    }),
    [types.SET_TAB_VISIBILITY]: (state, action) => ({ ...state, tabVisible: action.payload }),
};

export default createReducer(ACTION_HANDLERS, initialState);
